export default __webpack_public_path__ + "static/media/logoFD_w.3dccd2ec.svg";